const OpenManualStatuses = {
  1: "Published",
  2: "Hidden",
  3: "Deleted",
};
Object.freeze(OpenManualStatuses);

export { OpenManualStatuses };
